import React from 'react';
import { Outlet } from 'react-router-dom';

const UsersHome = () => {
  return (
    <section className="app-route">
      <Outlet />
    </section>
  );
};

export default UsersHome;